import { FC } from "react";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Segment } from "@/apis/bacchus/types";

interface ActionsCellProps {
  segment: Segment;
  onDeleteClick: (segment: Segment) => void;
  onEditClick: (segment: Segment) => void;
}

export const ActionsCell: FC<ActionsCellProps> = ({
  segment,
  onDeleteClick,
  onEditClick,
}) => {
  // Extract permissions (default to false if not present)
  const canEdit = segment.permissions?.write ?? false;
  const canDelete = segment.permissions?.delete ?? false;

  // Don't render anything if user has no actions available
  if (!canEdit && !canDelete) {
    return null;
  }

  const handleEdit = (event: React.MouseEvent) => {
    event.stopPropagation();
    onEditClick(segment);
  };

  const handleDelete = (event: React.MouseEvent) => {
    event.stopPropagation();
    onDeleteClick(segment);
  };

  return (
    <Stack direction="row" spacing={0.5}>
      {canEdit && (
        <Tooltip title="Edit name and description">
          <IconButton
            size="small"
            onClick={handleEdit}
            id={`segment-row-edit-${segment.id}`}
            data-testid={`segment-row-edit-${segment.id}`}
          >
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {canDelete && (
        <Tooltip title="Delete">
          <IconButton
            size="small"
            onClick={handleDelete}
            id={`segment-row-delete-${segment.id}`}
            data-testid={`segment-row-delete-${segment.id}`}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};
